import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/orders/OrdersClient.tsx");
